import { useMemo } from "react";

export function useId() {
  return useMemo(() => {
    let id = '';

    const characters = 'abcdefghijklmnopqrstuvwxyz';
    const charactersLength = characters.length;

    for (let i = 0; i < 4; i++) {
      id += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    return id;
  }, []);
}
